import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import type { RootState } from '../store';

/**
 * A prerelease feature's page (the backend's `PRERELEASE_FEATURES`). Nothing
 * renders until `/get_user_info` answers; a viewer it is hidden from (on prod,
 * anyone but Dooglie staff) is sent home rather than shown a page whose
 * requests answer `403 not_released`.
 */
export function PrereleaseRoute({ feature, children }: { feature: string; children: ReactNode }) {
  const hidden = useSelector((s: RootState) => s.user.hidden_features);
  if (hidden === undefined) return null;
  if (hidden.includes(feature)) return <Navigate replace to="/home" />;
  return <>{children}</>;
}
